import { useState } from 'react';
import { Box, Typography, Paper, Tabs, Tab, List, ListItem, Grid, Button } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import LaunchIcon from '@material-ui/icons/Launch';


const useStyles = makeStyles((theme) => ({
    topHeading: {
        display: 'flex',
        margin: theme.spacing(0.5, 0, 4, 0),
        alignItems: 'center',
    },
    search: {
        width: '100%',
        margin: theme.spacing(1, 8),
    },
    tabpanel: {
        overflowY: "scroll"
    }
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

export default function HelpPage() {
    const classes = useStyles();
    const [value, setValue] = useState(0);


    const handleChange = (_, newValue) => {
        setValue(newValue);
    };

    return (
        <Paper style={{ padding: '2em' }} variant="outlined">
            {/* <Box className={classes.topHeading}>
                <Typography variant="h4" style={{ flex: 1 }}>
                    Help
                </Typography>
            </Box> */}
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                <Tab label="Resources" />
                {/* <Tab label="Script - General" />
                <Tab label="Script - Non Profit Organizations" />
                <Tab label="Script - Professionals" /> */}
            </Tabs>
            <TabPanel value={value} index={0}>
                    <Grid container xs={12} >
                    <Grid container xs = {6} >
                    <List>
                    <Grid container xs ={12} spacing={1}>
                        <Grid item xs={8}>
                            <Typography variant="h4">Instructions</Typography>
                        </Grid>
                        <Grid item xs>
                        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1jHkmPbKvug1Ne0TASLIPIPS5OwRYLpeS2BAFoYUuuSo/edit#gid=93996880">
                            <Button color="secondary" 
                                variant="contained" disableElevation>
                                <LaunchIcon />
                            </Button>      
                        </a>
                        </Grid>
                    </Grid>
                    
                    <br/>
                    <Grid item xs={12}>
                        <Typography variant="h4"> Scripts </Typography>
                    </Grid>
                    <br/>
                    <ListItem>
                    <Grid container xs ={12} spacing={1}>
                        <Grid item xs={8}>
                            <Typography variant="h6">General Script</Typography>
                        </Grid>
                        <Grid item xs>
                        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/150IyXupuzhsUNIHrBK4SQEyELWPIMOOa/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">
                            <Button color="secondary" 
                                variant="contained" disableElevation>
                                <LaunchIcon />
                            </Button>      
                        </a>
                        </Grid>
                    </Grid>
                    </ListItem>
                    <ListItem>
                    <Grid container xs ={12} spacing={1}>
                        <Grid item xs={8}>
                            <Typography variant="h6">Specific Script for Non Profit Organizations</Typography>
                        </Grid>
                        <Grid item xs>
                        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/17OA4Gqd-UCHt3hdL4Kb4HhmcvRC6QPui/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">
                            <Button color="secondary" 
                                variant="contained" disableElevation>
                                <LaunchIcon />
                            </Button>      
                        </a>
                        </Grid>
                    </Grid>
                    </ListItem>
                    <ListItem>
                    <Grid container xs ={12} spacing={1}>
                        <Grid item xs={8}>
                            <Typography variant="h6">Specific Script for Professionals</Typography>
                        </Grid>
                        <Grid item xs>
                        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1aYj0kYsMh2afbZmdg-Ky2zbTAK_7k14C/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">
                            <Button color="secondary" 
                                variant="contained" disableElevation>
                                <LaunchIcon />
                            </Button>      
                        </a>
                        </Grid>
                    </Grid>
                    </ListItem>
                    <ListItem>
                    <Grid container xs ={12} spacing={1}>
                        <Grid item xs={8}>
                            <Typography variant="h6">Arabic Scripts</Typography>
                        </Grid>
                        <Grid item xs>
                        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1Dy7am_wVtlxTvg4nrmyKbU2ZFJ5n-8Ze/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">
                            <Button color="secondary" 
                                variant="contained" disableElevation>
                                <LaunchIcon />
                            </Button>      
                        </a>
                        </Grid>
                    </Grid>
                    </ListItem>
                    
                    </List>
                    </Grid>
                    <Grid container xs={6}>
                    <List>
                    <Grid item xs={12}>
                        <Typography variant="h4"> Global Nomenclature </Typography>
                    </Grid>
                    <br/>
                    <ListItem>
                    <Grid container xs ={12} >
                        <Grid item xs={6}>
                            <Typography variant="h6">Nomenclature</Typography>
                        </Grid>
                        <Grid item xs = {2}>
                        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/17Z9vXVVKg037mJ6-f8NR8GpufSsWNYXc/edit#gid=1657357615">
                            <Button color="secondary" 
                                variant="contained" disableElevation>
                                <LaunchIcon />
                            </Button>      
                        </a>
                        </Grid>
                    </Grid>
                    </ListItem>
                    <br/>
                    <Grid item xs={12}>
                        <Typography variant="h4"> Detailed Nomenclature </Typography>
                    </Grid>
                    <br/>
                    
                    <Grid container xs={12}>
                    <Grid container xs={6}>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1g2on7vSV6a3HOJ0jdSiFwLj8CflezqtC/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">Amusement</Button>   
                    </ListItem>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1_DE810699dqUHzjo7IiRNInU1kb3dmgw/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">Architecture</Button>
                        
                    </ListItem>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/10cxU5arBmPyolrRkG1c5b1VUY4VROFPl/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">Arts & Culture</Button>
                    </ListItem>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1nwRrZQUMPYX4ELsH4v39jW25vwnWxpDv/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">Beauty & Wellness</Button>
                    </ListItem>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1eqHLQx8i-R4b7yfgx0aeVMbvxnPJEmhr/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">Do a Good Deed</Button>
                    </ListItem>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1PSJcD5wevCq0sCQGksJOED3LbGQ6MKQM/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">F&B & Nightlife</Button>
                    </ListItem>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1mNjcjFqugrzJxHL1dtbxeBM6n7drLBJ0/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">Learn & Improve Your Skills</Button>
                    </ListItem>
                    </Grid>
                    <Grid container xs={6}>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1x8md_OcRce7WjEuEAVISifvUZYoo2tuu/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">One-of-a-Kind Experiences in the UAE</Button>
                    </ListItem>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1IaVIC-OZVjC8RQbohIDpLCJsBGSjnPcS/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">Outdoor Places</Button>
                    </ListItem>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1eRd-Yi3TzjNHwy2t7G2Lbhx_XdnBufpW/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">Recreational Means of Transportation</Button>
                    </ListItem>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1s8hjxvOI202RDkFtam-qnxt9c_VqzN8h/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">Science & Technology</Button>
                    </ListItem>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1VkZreyg_-FkYEcPxAH_IpoMybsMWE3Gr/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">Shopping</Button>
                    </ListItem>
                    <ListItem>
                        <Button color="primary" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1e0v_2j3hh0aR9fnPGcC_SP9aKK8_9fhE/edit?usp=sharing&ouid=107508319816939757906&rtpof=true&sd=true">Sports & Games</Button>
                    </ListItem>
                    </Grid>
                    </Grid>

                    <br/>
                    <Grid item xs={12}>
                        <Typography variant="h4"> London dataset Database </Typography>
                    </Grid>
                    <br/>
                    <ListItem>
                    <Grid container xs ={12} >
                        <Grid item xs={6}>
                            <Typography variant="h6">Provider list from London dataset</Typography>
                        </Grid>
                        <Grid item xs = {2}>
                        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1m07EiPeqWmgYc1yPQrXklmQ_KQ9k36Lr/edit#gid=1286150568&range=A1283">
                            <Button color="secondary" 
                                variant="contained" disableElevation>
                                <LaunchIcon />
                            </Button>      
                        </a>
                        </Grid>
                    </Grid>
                    </ListItem>
                </List>
                
                </Grid>
                </Grid>
                
            </TabPanel>
            {/* <TabPanel value={value} index={1}>
                <Typography variant="body">
                    Work in progress
                </Typography>
            </TabPanel>
            <TabPanel value={value} index>
                <Typography variant="body">
                    Work in progress
                </Typography>
            </TabPanel>
            <TabPanel value={value} index={3}>
                <Typography variant="body">
                    Work in progress
                </Typography>
            </TabPanel> */}
        </Paper>
    )
}